import { Action, combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
//split imports
import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { FN_SERIALIZATION__data_deserialize } from '@shared/serialization/FN_SERIALIZATION__data_deserialize';
import { ENUM__redux_slice } from './_base/ENUM__redux_slice';
import { middleware_log_rejected_state } from './_middlewares/middleware_log_rejected_state';
import { slice_reducers } from './store_slices';
import { slice_ui_initial_state } from './ui/slice_ui';
import { slice_user_initial_state } from './user/slice_user_initial_state';
import { StateUser } from './user/state_user';

const persist_config = {
  key: 'root',
  storage,
  whitelist: [ENUM__redux_slice.USER, ENUM__redux_slice.UI],
  transforms: [
    {
      in: (state_raw: any, key: string) => {
        let out = state_raw;

        switch (key) {
          case ENUM__redux_slice.USER: {
            let state: StateUser = state_raw;
            // Only persist auth_token from auth slice
            out = {
              ...slice_user_initial_state,
              auth_token: state.auth_token,
              user_id: state.user_id,
              open_page_after_auth: state.open_page_after_auth,
            };

            break;
          }

          case ENUM__redux_slice.UI: {
            out = { ...slice_ui_initial_state };
            break;
          }

          case ENUM__redux_slice._PERSIST: {
            //do nothing
            break;
          }

          default: {
            not_implemented_type(key);
          }
        }

        return out;
      },
      out: (state_raw: any, key: string) => {
        switch (key) {
          case ENUM__redux_slice.USER: {
            for (let [key, value] of Object.entries(state_raw)) {
              state_raw[key] = FN_SERIALIZATION__data_deserialize(value);
            }

            break;
          }

          case ENUM__redux_slice._PERSIST:
          case ENUM__redux_slice.UI: {
            //do nothing
            break;
          }

          default: {
            not_implemented_type(key);
          }
        }

        return state_raw;
      },
    },
  ],
};

export const rootReducer = combineReducers(slice_reducers);

const persistedReducer = persistReducer(persist_config, rootReducer);

export type RootState = ReturnType<typeof rootReducer>;

export const rootReducerWithUndo = (state: RootState | undefined, action: Action): RootState => {
  if (action.type === 'UNDO' && 'payload' in action) {
    return { ...(action.payload as RootState) };
  }
  return persistedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducerWithUndo,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      //in ms
      //TOOD: ARCHITECTURE + OMPTIMIZATION, review what we store in redux
      immutableCheck: { warnAfter: 1000 },
      serializableCheck: false,
    }).concat(middleware_log_rejected_state),
});

// 👇 attach for debugging
if (typeof window !== 'undefined') {
  (window as any).store = store;
}

export function init_redux_persist_store() {
  persistStore(store, null, () => {});
}

export type AppDispatch = typeof store.dispatch;
